export default {
    lineColor: 'rgb(0,0,0)',
    lineWidth: 2,
    fillColor: 'rgba(0,0,0,0)'
};



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/annotations/defaults/point.js